import { useEffect } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { toast } from 'react-toastify';
import PermissionsControls from './components/PermissionsControls';
import PermissionsTable from './components/PermissionsTable';
import { useRolesStore } from '../invitation/state/use-roles-store';
import { usePermissionsStore } from './state/use-permissions-store';

const PermissionsContent = () => {
  const { roles, fetchRoles } = useRolesStore();
  const { isLoading, error, loadPermissions, savePermissions } = usePermissionsStore();

  const methods = useForm({
    defaultValues: { role: '', sections: [] },
    mode: 'onChange',
  });
  const { control, reset, handleSubmit } = methods;
  const selectedRole = useWatch({ control, name: 'role' });

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  useEffect(() => {
    if (!roles?.length || methods.getValues('role')) return;
    reset({ role: roles[0].key, sections: [] });
  }, [roles, reset, methods]);

  useEffect(() => {
    if (!selectedRole) return;

    loadPermissions({
      role: selectedRole,
      dataCb: (sections) => reset({ role: selectedRole, sections }),
    });
  }, [selectedRole, loadPermissions, reset]);

  const successHandle = (values) => {
    reset(values);
    toast.success('Права доступа сохранены');
  };

  const handleSave = handleSubmit(async (values) => {
    await savePermissions({ values, dataCb: () => successHandle(values), errCb: () => toast.error('Не удалось сохранить права') });
  });

  return (
    <FormProvider {...methods}>
      <PermissionsControls roles={roles} onSave={handleSave} />
      <PermissionsTable isLoading={isLoading} error={error} />
    </FormProvider>
  );
};

export default PermissionsContent;
